import { GamesBreadcrumb } from "./index";
import { PlayGameLink } from "./index";

export default function HangmanGameInfo() {
  return (
    <div className="p-4 bg-white dark:bg-slate-900/80 rounded-xl shadow">
      <GamesBreadcrumb game="Hangman" />
      <h1 className="text-3xl font-bold mb-4 text-slate-900 dark:text-slate-100">Hangman</h1>
      <img
        src="/thumbnails/Hangman.png"
        alt="Hangman game screenshot"
        className="rounded-lg shadow mb-4 w-full max-w-md mx-auto bg-white dark:bg-slate-800"
      />
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">About Hangman</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Hangman is a classic word guessing game where players try to guess a hidden word by suggesting letters within a certain number of attempts. The game is played with a series of blank spaces representing the letters of the word, and incorrect guesses result in parts of a stick figure being drawn. Hangman is a fun and educational game that helps improve vocabulary and spelling skills.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">How to Play</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Players take turns guessing letters to reveal the hidden word.</li>
          <li>Each incorrect guess results in a part of the hangman being drawn.</li>
          <li>The game ends when the word is guessed correctly or the hangman is fully drawn.</li>
          <li>Players can use strategy and deduction to guess the word with fewer mistakes.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">History</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Hangman is believed to have originated in the 19th century as a paper-and-pencil game. It has since become a popular educational tool for teaching spelling and vocabulary in classrooms around the world.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Strategy Tips</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Start with common vowels and consonants to increase your chances of revealing letters.</li>
          <li>Pay attention to letter patterns and word length to make educated guesses.</li>
          <li>Use process of elimination to narrow down possible words.</li>
        </ul>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Play Hangman</h2>
          <p className="text-gray-700 dark:text-gray-300">
          You can play Hangman for free with friends or other players right here on Game for a Laugh! No download or registration required.
        </p>   
        <PlayGameLink game="Hangman" />
      </section>
    </div>
  );
}
